export default __webpack_public_path__ + "5e7882c25f80ead21c4b7fa3d8e7c1a3.png";